'use client';
import React from 'react';
import { useParams, usePathname, useSearchParams } from 'next/navigation';
import { Link } from '@components/Link';
import cn from './style.module.scss';
export default function GardeniaLaunchHeader(props: any) {
  const { t } = props;
  const { lang } = useParams();
  const pathname = usePathname();
  let params: Record<string, string> = {};
  const searchParams = useSearchParams();
  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  const getLangUrl = () => {
    let url = `/${lang === 'en' ? 'ar' : 'en'}/launch/Yas-Riva`;
    if (pathname.includes('register')) {
      url = `${url}/register`;
    }
    return url;
  };

  return (
    <>
      <header className={cn.launchGardeniaHeader}>
        <div className={cn.launchGardeniaInner}>
          <div className={cn.launchGardeniaNavigation}>
            <div className={cn.launchGardeniaCompany}>
              <Link
                className={cn.companyGardeniaButton}
                url="https://www.aldar.com/properties/en"
                target="_blank"
              >
                <span>{t['goToAldar']}</span>
                <span className={cn.launchGardeniaIcon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 10.683"
                  >
                    <path
                      id="icons-arrows-right-arrow-white"
                      d="M3,9.834H16.17L13.294,7.055A.938.938,0,0,1,13.34,5.74,1.028,1.028,0,0,1,14.7,5.7L20,10.8,14.7,15.9a1.028,1.028,0,0,1-1.365-.044.938.938,0,0,1-.046-1.315l2.881-2.783H3A.964.964,0,1,1,3,9.834Z"
                      transform="translate(-2 -5.458)"
                      fillRule="evenodd"
                    />
                  </svg>
                </span>
              </Link>
            </div>
            <div className={cn.launchGardeniaRegister}>
              <a className={cn.launchGardeniaButton} href="#launchGRDContact">
                <span>{t['actionButton']}</span>
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
